import "../App.css";

const STATS = [
  { label: "Battle IQ",  key: "battleIQ",          scoreKey: "battleIQScore"   },
  { label: "Strength",   key: "physical strength",  scoreKey: "strengthScore"   },
  { label: "Durability", key: "durability",          scoreKey: "durabilityScore" },
  { label: "Stamina",    key: "stamina",             scoreKey: "staminaScore"    },
  { label: "Speed",      key: "speed",               scoreKey: "speedScore"      },
  { label: "Mindset",    key: "mindset",             scoreKey: "mindsetScore"    },
];

function CharacterCard({ character, isWinner, opponent }) {
  const outcomeClass = isWinner === true ? "card-winner" : isWinner === false ? "card-loser" : "";

  return (
    <div className={`character-card ${outcomeClass}`}>
      <div className="card-winner-badge">{isWinner ? "WINNER" : ""}</div>

      <div className="card-portrait">
        <div className="card-portrait-name">{character.name}</div>
      </div>

      <div className="card-prob-badge">{character.probability}% win chance</div>

      {(character.height || character.weight || character.species) && (
        <div className="card-physical-row">
          {character.species && <span className="card-physical-item">{character.species}</span>}
          {character.height && <span className="card-physical-item">{character.height}</span>}
          {character.weight && <span className="card-physical-item">{character.weight}</span>}
        </div>
      )}

      {(character.fightingStyle || character.threatLevel) && (
        <div className="card-combat-tags">
          {character.fightingStyle && (
            <span className={`card-tag card-tag-style card-tag-style-${character.fightingStyle.replace(/\s+/g, "-")}`}>
              {character.fightingStyle}
            </span>
          )}
          {character.threatLevel && (
            <span className={`card-tag card-tag-threat card-tag-threat-${character.threatLevel}`}>
              {character.threatLevel}
            </span>
          )}
        </div>
      )}

      <p className="card-summary">{character.summary}</p>

      <div className="card-stats">
        {STATS.map(({ label, key, scoreKey }, i) =>
          character[key] ? (
            <div key={key} className="card-stat-row">
              <span className="card-stat-label">{label}</span>
              {typeof character[scoreKey] === "number" ? (
                <div className="card-stat-bar-wrap">
                  <div
                    className={`card-stat-bar ${
                      opponent && typeof opponent[scoreKey] === "number"
                        ? character[scoreKey] > opponent[scoreKey] ? "bar-winner"
                          : character[scoreKey] < opponent[scoreKey] ? "bar-loser"
                          : "bar-draw"
                        : isWinner ? "bar-winner" : "bar-loser"
                    }`}
                    style={{
                      "--bar-width": `${character[scoreKey]}%`,
                      animationDelay: `${0.15 + i * 0.1}s`,
                    }}
                  />
                  <span className="card-stat-score">{character[scoreKey]}</span>
                </div>
              ) : (
                <span className="card-stat-value">{character[key]}</span>
              )}
              {typeof character[scoreKey] === "number" && character[key] && (
                <div className={`card-stat-tooltip${i >= 3 ? " tooltip-up" : ""}`}>{character[key]}</div>
              )}
            </div>
          ) : null
        )}
      </div>

      {character.abilities && (
        <div className="card-tag-section">
          <span className="card-tag-heading">Abilities</span>
          <p className="card-tag-list">{character.abilities}</p>
        </div>
      )}

      {character.strengths && (
        <div className="card-tag-section">
          <span className="card-tag-heading">Strengths</span>
          <p className="card-tag-list">{character.strengths}</p>
        </div>
      )}

      {character.weaknesses && (
        <div className="card-tag-section">
          <span className="card-tag-heading">Weaknesses</span>
          <p className="card-tag-list">{character.weaknesses}</p>
        </div>
      )}
    </div>
  );
}

export default CharacterCard;
